import {env} from '@/config';
import NotFound from '@/pages/not-found';

import {Company} from '@/types/company';
import {Box, Grid} from '@mui/material';

import ResponsiveDrawer from '@/components/admin/companies/drawer';

import {useCompanyContext} from '@/contexts/admin/companies';
import {useAppSelector} from '@/redux-store/store';

const {SERVER} = env;
interface CompanyDetailsProps {
  company: Company;
  hasCompanyId: boolean;
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({
  company,
  hasCompanyId
}) => {
  const companyContext = useCompanyContext();

  const employees = useAppSelector((state) => state.company.employees);

  const userRole = useAppSelector((state) => state.auth.keycloakUser?.userRole);

  const isAdmin = userRole && userRole === 'ADMIN';

  const companyStatistics = companyContext?.companyStatistics || null;

  const companyEmployees =
    hasCompanyId && isAdmin ? companyContext?.companyEmployees : employees;

  const companyId = company?._id;

  const registerLink = `${SERVER}/api/sjone/register/${companyId}`;

  const accessCodes = company?.accessCodes;

  if (!company) {
    return <NotFound />;
  }

  return (
    <>
      <Box marginTop={3}>
        <Grid container direction="column" justifyContent="center" spacing={1}>
          <Grid item xs={12}>
            <ResponsiveDrawer
              company={company}
              registerLink={registerLink}
              accessCodes={accessCodes}
              companyEmployees={companyEmployees}
              companyStatistics={companyStatistics}
              responsiveAppBarView={hasCompanyId}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CompanyDetails;
